// extracted by mini-css-extract-plugin
module.exports = {"upper":"Layout_upper__01hxz"};